import { MRF_DETAILS, MRF_DETAILS_BY_GATE } from "./type";

const initialState = {
  mrfDetails: {},
  mrfDetailsByGate: {},
};

const mrfDetailsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case MRF_DETAILS:
      return {
        ...state,
        mrfDetails: payload,
      };
    case MRF_DETAILS_BY_GATE:
      return {
        ...state,
        mrfDetailsByGate: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default mrfDetailsReducer;
